import styled from "styled-components";
 
export const GoTribeReviewFooterWrapperOuterWrapper = styled.div(
  (props) => `
        height: 40px;
        margin: ${props.margin && props.margin};
        background: #fff;
        position:relative;
        `
);
 
export const GoTribeReviewFooterWrapper = styled.div(
  (props) => `
   background: ${props.theme.colors.goWhite.base};
    display: flex;
    width: 100%;
    height: 40px;
    overflow:hidden;
    position: relative;
    border-top:1px solid #e6e6e6;
    border-bottom:1px solid #e6e6e6;
}
      `
);
 
export const GoTribeTextWrapper = styled.div(
  (props) => `
    width: 71px;
    height: 71px;
    background: ${props.iconColor};
    position: absolute;
    border-radius: 50%;
    top: -16px;
    left: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 4px;
      `
);

export const GoTribeImageWrapper = styled.img.attrs((props) => ({
  src: props.src || "",
}))`
  width: 50px;
  margin: 0 0.5rem 0 0.5rem
`;
 
export const GoTribeReviewFooterText = styled.p(
  (props) => `
    font-weight: 500;
    font-size: 14px;
    margin-left: 7.2rem;
    padding: 1.2rem 2.5rem 1.2rem 0;
    font-family: 'Rubik';
    line-height: 1.6rem;
    color: ${props.theme.colors.downriver.base};
      `
);